export const UIEvent = {
    SCROLL_H : "SCROLL_H",
    SCROLL_V : "SCROLL_V",
    SIZE_CHANGED : "SIZE_CHANGED",
    PERCENT_CHANGED : "PERCENT_CHANGED",
}


// WEBPACK FOOTER //
// ./src/common/scripts/pixi/const/Event.js